import Flex from '../data/Flex';
import UIFlex, { copyFlex, IUIFlexProps } from './UIFlex';
import UILoadingIcon from './UILoadingIcon';

export interface IUILoadingBoxProps extends IUIFlexProps{
    fullHeight?:boolean;
}

export function UILoadingBox ($props:IUILoadingBoxProps) {

    let flex = copyFlex({alignItems:Flex.CENTER, justifyContent:Flex.CENTER},$props.flex);

    if($props.fullHeight){
        flex.style = {...flex.style, height:"100%"};
    }
    let cn:string = "loadingBox";
    if($props.className){
        cn+=" "+$props.className;
    }
    return (
        <UIFlex className={cn} flex={flex}>
            <UILoadingIcon/>
            {$props.children}
        </UIFlex>
    );
}
